import { createFileRoute } from '@tanstack/react-router';
import ApplicationClaimPage from '@/components/DeveloperApplications/ApplicationClaimPage';

export const Route = createFileRoute('/developers/applications/claim')({
  component: ApplicationClaimPage,
});
